export const URL_STRINGS = {
	// used in .com/producer/meetingId
	// used in .com/producer/create-account
	// used in .com/producer/password-reset
	PRODUCER: 'producer',
	// used in .com/onsite/meetingId(sladkfk)
	ONSITE: 'onsite',
	// used in .com/stream/meetingId
	STREAM: 'stream',
	// used in .com/embed/meetingId
	EMBED: 'embed',
	// used in .com/password-reset
	PASSWORD: 'password-reset',
	// used in .com/create-account
	CREATE: 'create-account',
	// used in .com/verify-account
	VERIFY: 'verify-account',
};

export enum ProgramViewType {
	None = 'none',
	ProgramFeed = 'program-feed',
	// full screen version of the canvas (a public facing version of the embed view)
	OnsiteFeed = 'onsite-feed',
	// program feed that mutes designated "onsite" feeds
	OnsiteLocation = 'onsite-location',
	// 2nd iteration of the onsite feature, changes canvas layout to remove designated "onsite" feeds
}

export type LimitedInputViewType = 'canvas' | 'presenter' | 'none';

export interface LimitedInputConfig {
	view: LimitedInputViewType;
	smartCanvas: boolean;
	locationId: number | null;
}
